import type { ReactNode } from 'react';

import { SiteFooter } from './site-footer';
import { SiteHeader } from './site-header';

import css from './page.module.css';

/**
 * Header, the page's content as <main>, footer. `flush`: no bottom padding (the
 * last section has its own). `underHeader`: the first section of <main> (the
 * hero), drawn under a transparent header — its photo and veil fill the
 * header's band too, as in miami's mockup; see page.module.css.
 */
export function Page({
  children,
  flush,
  underHeader,
}: {
  children: ReactNode;
  flush?: boolean;
  underHeader?: ReactNode;
}) {
  const main = `${css.main} ${flush ? css.flush : ''}`;

  if (!underHeader) {
    return (
      <div className={css.page}>
        <SiteHeader />
        <main className={main}>{children}</main>
        <SiteFooter />
      </div>
    );
  }

  return (
    <div className={`${css.page} ${css.pageUnder}`}>
      <SiteHeader transparent />
      <main className={`${main} ${css.mainUnder}`}>
        {underHeader}
        <div>{children}</div>
      </main>
      <SiteFooter />
    </div>
  );
}

/** The narrow intro block of a list page: lead paragraph under the <h1>. */
export function Intro({ children }: { children: ReactNode }) {
  return <p className={css.intro}>{children}</p>;
}
